import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ConfigService } from './config.service';
import { AuthenticationService } from './authentication.service';
import { StorageService } from './storage.service';



@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrls
  private breadCrumb
  private quantrolBase
  userData:any


  constructor(private http: HttpClient, private configService: ConfigService, private authService: AuthenticationService, private storageService : StorageService) {
    this.baseUrls = this.configService?.getRatelocApiUrl();
  this.breadCrumb = this.configService?.getBreadcrumb();
  this.quantrolBase = this.configService?.getQuamtrolApiUrl()
  this.userData = this.authService.getData();
  }


  getUserById(userId: any) {
    const headers = this.getHeaders();
    // const url = `${this.API}/getUserById/${userId}`;
    const url = `${this.baseUrls}${this.breadCrumb?.onboarding}/getUserById/${userId}`;
    return this.http.get(url, { headers });
  }

  getExpenses(obj:any) {
    // const url = `${this.API}/getUserById/${userId}`;
    // headers['X-ACCESS-TOKEN'] = sessionStorage.getItem('accessToken');
    this.userData = this.authService.getData();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.storageService.getToken()}`,
      'X-ACCESS-TOKEN' : this.storageService.getAccessToken()
    });
    let url = this.quantrolBase + this.breadCrumb?.expenses;
    if(obj != undefined || obj != null) {
    url += '?page=' + obj.page
    url += obj?.size ? '&size=' + obj.size : '&size=25'
  if(obj.all) url += '&all=' + obj.all
  if(obj.search) url += '&all=true&search=' + obj.search
  if(obj.status) url += '&paymentStatus=' + obj.status
  if(obj.paidMonth) url += '&paymentDate=' + obj.paidMonth
  if(obj.month) url += '&month=' + obj.month
  }
    return this.http.get(url, {headers});
  }

  createExpense( data:any) {
    // const url = `${this.API}/getUserById/${userId}`;
    this.userData = this.authService.getData();
    const headers = this.getHeaders();
    const url = this.quantrolBase + this.breadCrumb?.createExpense;
    return this.http.post(url, data, {headers});
  }

  updateExpense( data:any) {
    // const url = `${this.API}/getUserById/${userId}`;
    this.userData = this.authService.getData();
    const headers = this.getHeaders();
    const url = this.quantrolBase + this.breadCrumb?.expenses + '/' + data.id;
    return this.http.put(url, data, {headers});
  }

  deleteExpense( id:any) {
    // const url = `${this.API}/getUserById/${userId}`;
    this.userData = this.authService.getData();
    const headers = this.getHeaders();
    const url = this.quantrolBase + this.breadCrumb?.expenses + '/' + id;
    return this.http.delete(url, {headers:headers});
  }

  updateUserById(userId: any, data: any, headers: any) {
    // const url = `${this.API}/updateUserById/${userId}`;
    const url = `${this.baseUrls}${this.breadCrumb?.onboarding}/updateUserById/${userId}`;
    return this.http.patch(url, data, { headers }); // Assuming you're using PATCH method for updating
  }

  updateUser(userId: any, data: any, headers: any) {
    // const url = `${this.updateUrl}/updateBooking/${userId}`;
    const url = `${this.baseUrls}${this.breadCrumb?.accommodation}/updateBooking/${userId}`;
    return this.http.post<any>(url, data, { headers });

  }

  getInHouseUsers(headers: any){
    return this.http.get(this.baseUrls + this.breadCrumb?.getInHouseUsers, { headers });
  }

  // Get All Users
  getAllUsers(obj:any) {
    const headers = this.getHeaders();
    if(['OWNER', 'MASTER_ADMIN'].includes(this.storageService.getUserRoles())) obj['tenantKey'] = this.storageService.getTenantKey()
    return this.http.post(this.quantrolBase + this.breadCrumb?.alluser, obj, { headers });
  }

  getAllTenants() {
    const headers = this.getHeaders();
    return this.http.get(this.quantrolBase + this.breadCrumb?.tenants, { headers });
  }

  fetchContactById(id: any) {
    // return this.http.get(`${this.API}/getUserById/${id}`);
    const headers = this.getHeaders();
    let tenantKey = ['OWNER', 'MASTER_ADMIN'].includes(this.storageService.getUserRoles()) ? '?tenantKey=' + this.storageService.getTenantKey() : ''
    return this.http.get(`${this.quantrolBase}${this.breadCrumb?.getUserById}/${id}${tenantKey}`, { headers });
  }

  updateContact(data: any, id: any) {
    const headers = this.getHeaders();
    return this.http.put(`${this.quantrolBase}${this.breadCrumb?.getUserById}/${id}`, data, {headers}); // Assuming updateUser endpoint with PUT method
  }

  // Post Method
  addcontact(data: any) {
    return this.http.post(this.baseUrls + this.breadCrumb?.postuser, data)
  }

  // Method to fetch all bookings
  getAllBookings(headers: any, obj?:any): Observable<any> {
    // return this.http.get(`${this.API_URL}/bookings`,headers);
    let url = ''
      if(obj != undefined || obj != null) {
      url = '?page=' + obj.page + '&size=50' + '&inhouseUser=' + obj.inhouse
    if(obj.all) url += '&all=' + obj.all
    if(obj.search) url += '&all=true&search=' + obj.search
    if(obj.status) url += '&bookingStatus=' + obj.status
    if(obj.paidByName) url += '&paidBy=' + obj.paidByName
    if(obj.supplierName) url += '&supplierName=' + obj.supplierName
    if(obj.monthDeadLineDate) url += '&deadlineMonth=' + obj.monthDeadLineDate
    if(obj.supplierDueMonth) url += '&supplierDueDate=' + obj.supplierDueMonth
    if(obj.supplierPaid) url += '&supplierPaid=' + obj.supplierPaid
    if(obj.customerPaidStatus || obj.priceStatus) url += '&customerPaid=' + (obj.customerPaidStatus || obj.priceStatus)
    if(obj.bookedOnMonth) url += '&bookedOn=' + obj.bookedOnMonth
    if(obj.checkInMonths) url += '&checkIn=' + obj.checkInMonths
    if(obj.nights) url += '&nights=' + obj.nights
    if(obj.roomCount) url += '&roomCount=' + obj.roomCount
    if(obj.filterType == 'refundStatus' || obj.filterType == 'cancelledNear' ) url += '&filterType=' + (obj.filterType == 'refundStatus' ? 'refunded' : 'cancelledNear')
    }
    return this.http.get(this.baseUrls + this.breadCrumb?.allBookings + url, headers);
  }

  // bookingCancel(obj: any): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${sessionStorage['authToken']}`,
  //   });
  //   // return this.http.post(this.CANCEL_API + 'accommodation/bookingCancel', obj, {
  //   //   headers,
  //   // });
  //   return this.http.post(this.baseUrls + this.breadCrumb?.bookingsCancel, obj, {
  //     headers,
  //   });
  // }

  // getWalletMoneyRequest(userId: any): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${sessionStorage['authToken']}`,
  //   });
  //   return this.http.get(this.baseUrls + this.breadCrumb?.walletMoneyRequest + '/' + userId, {
  //     headers,
  //   });
  // }

  // getAllSupplierUplift(): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${sessionStorage['authToken']}`,
  //   });
  //   return this.http.get(this.baseUrls + this.breadCrumb?.supplier, {
  //     headers,
  //   });
  // }

  // bookingHistory(userId: any): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${sessionStorage['authToken']}`,
  //   });
  //   return this.http?.get(this.baseUrls + this.breadCrumb?.bookingHistory + '/' + userId, {
  //     headers,
  //   });
  // }

  // getUserByIdforWalletBalance(userId: any): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${sessionStorage['authToken']}`,
  //   });
  //   return this.http.get(this.baseUrls + this.breadCrumb?.getUserById + '/' + userId, {
  //     headers,
  //   });
  // }
  // walletStatusUpdate(id: any, obj: any): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${sessionStorage['authToken']}`,
  //   });
  //   return this.http.patch(this.baseUrls + this.breadCrumb?.walletStatusUpdate + '/' + id, obj, {
  //     headers,
  //   });
  // }

  getAllSupplier(headers:any): Observable<any> {
    // return this.http.get(`${this.supplierUrl}`,{headers});
    return this.http.get(this.baseUrls + this.breadCrumb?.getAllSupplier, { headers });

  }

  getLoginDetail(headers: any) {
    // return this.http.get<any>(`${this.API}/login`,{headers})
    return this.http.get<any>(this.baseUrls + this.breadCrumb?.login, { headers })
  }
  getOtp() {
    this.userData = this.authService.getData();
    const headers = this.getHeaders();
    return this.http.post<any>(this.quantrolBase + this.breadCrumb?.getOtp + '?email=' + this.userData.email, {}, {headers} )
  }

  getLogin(obj: any) {
    return this.http.post<any>(this.quantrolBase + this.breadCrumb?.login, obj)
  }

  verifyOtp(otp:any) {
    this.userData = this.authService.getData();
    const headers = this.getHeaders();
    return this.http.post<any>(this.quantrolBase + this.breadCrumb?.verifyOtp + '?email=' + this.userData.email + '&otp='+otp, {}, { headers })
  }

  getHeaders() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.storageService.getToken()}`,
    });
    return headers
  }

  setPassword(obj: any) {
    return this.http.post<any>(this.quantrolBase + this.breadCrumb?.setPassword+obj.email, obj)
  }

  getRatelocLogin(obj: any) {
    return this.http.post<any>(this.baseUrls + this.breadCrumb?.login, obj)
  }

  getDashboardDetails(headers: any) {
    // return this.http.get<any>(`${this.dashboardUrl}`,{headers})
    return this.http.get<any>(this.baseUrls + this.breadCrumb?.dashboard, { headers })

  }

  // addSupplier(obj: any) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${sessionStorage['authToken']}`,
  //   });

  //   // return this.http.post<any>(this.addSupplierUrl,obj,{headers})
  //   return this.http.post<any>(this.baseUrls + this.breadCrumb?.addSupplier, obj, { headers })


  // }

  // updateSupplier(obj: any) {
  //   // return this.http.post<any>(this.updateSupplierUrl,obj ,{headers})
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${sessionStorage['authToken']}`,
  //   });
  //   return this.http.post<any>(this.baseUrls + this.breadCrumb?.updateSupplier, obj, { headers })

  // }

  updateApiHealth(sname: any, data: any, headers: any) {
    //  const url = `${this.updateApiHealthUrl}`;
    //  return this.http.post<any>(url, data, {headers});
    return this.http.post<any>(this.baseUrls + this.breadCrumb?.updateApiHealth, data, { headers });

  }
  // createBooking(data: any) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${sessionStorage['authToken']}`,
  //   });
  //   return this.http.post<any>(this.baseUrls + this.breadCrumb?.createBooking, data, { headers });

  // }

  // deleteUser(selectedId: any) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${sessionStorage['authToken']}`,
  //   });
  //   const url = `${this.baseUrls}${this.breadCrumb?.onboarding}/deleteUserById/${selectedId}`;

  //   return this.http.delete(url, { headers })
  // }


// updateCurrency(baseCurrency: any, symbolCurrency: any): Observable<any> {
//   //baseCurrency == actual currency  symbolCurrency == converted Currency
//   return this.http.get('https://api.exchangeratesapi.io/v1/latest?access_key=176e499bbf0d29fd3d9610b43553d44b&base=' + baseCurrency +'&symbols=' + symbolCurrency);
// }

// updateCurrency(baseCurrency: any, symbolCurrency: any): Observable<any>{
//     const headers = new HttpHeaders({
//       'Content-Type': 'application/json',
//       // Authorization: `Bearer ${sessionStorage['authToken']}`,
//       Authorization: `Bearer ${'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJtb2hkc2FsbWFuQHJhdGVsb2MuY29tIiwiaWF0IjoxNzQ5NDc0MTU4fQ.SlmmJCMCa39U-3lcI6HtQ2mQR3rX9slFyh_7oXOcLhM'}`,
//     });
//     return this.http?.get(this.baseUrls + 'accommodation/currencyConversion?from=' + baseCurrency + '&to=' + symbolCurrency, {
//       headers,
//     });
//   }

}
